import React, { useEffect, useState } from "react";
import axios from '../../axios/axiosconf';
import { useHistory } from "react-router";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import Loading from "../general/Loading";
import Unauthorized from "../general/Unauthorized";

function PlantillasHistoriaClinica() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [plantillas, setPlantillas] = useState([]);
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    
    useEffect(() => {
        if (!localStorage.getItem('userdata')) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        
        // Validación de permisos híbrida
        let tienePermiso = false;
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some(p => p.slug === 'administrarPlantillas');
        } else if (userdata.up && userdata.up.includes('administrarPlantillas')) {
            tienePermiso = true;
        }
        
        if (!tienePermiso) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }
        
        setHasPermission(true);
        cargarDatos(userdata);
    }, []);
    
    const cargarDatos = (userdata) => {
        setLoading(true);
        
        // Cargar cliente
        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                }
            })
            .catch(error => console.error(error));
        
        // Cargar plantillas
        axios.get('/plantillas-historia-clinica')
            .then(response => {
                setPlantillas(response.data);
                setLoading(false);
                setLoggedIn(true);
            })
            .catch(error => {
                console.error(error);
                setLoading(false);
                setLoggedIn(true);
            });
    };
    
    const eliminarPlantilla = (id, nombre) => {
        if (!window.confirm(`¿Está seguro de eliminar la plantilla "${nombre}"?`)) {
            return;
        }
        
        setLoading(true);
        
        axios.delete(`/plantillas-historia-clinica/${id}`)
            .then(response => {
                alert('Plantilla eliminada exitosamente');
                // Recargar plantillas
                axios.get('/plantillas-historia-clinica')
                    .then(response => {
                        setPlantillas(response.data);
                        setLoading(false);
                    })
                    .catch(error => {
                        console.error(error);
                        setLoading(false);
                    });
            })
            .catch(error => {
                console.error(error);
                alert('Error al eliminar plantilla: ' + (error.response?.data?.message || 'Error desconocido'));
                setLoading(false);
            });
    };
    
    if (hasPermission === false) return <Unauthorized />;
    if (!loggedIn) return <Loading />;
    
    return (
        <div className="hold-transition sidebar-mini">
            <div className="wrapper">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <section className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1>
                                        <i className="fas fa-file-medical"></i> Plantillas Historia Clínica
                                    </h1>
                                </div>
                                <div className="col-sm-6">
                                    <button 
                                        className="btn btn-primary float-right"
                                        onClick={() => history.push('/crear-plantilla-historia-clinica')}
                                    >
                                        <i className="fas fa-plus"></i> Nueva Plantilla
                                    </button>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="card">
                                <div className="card-header">
                                    <h3 className="card-title">Listado de Plantillas</h3>
                                </div>
                                <div className="card-body">
                                    {loading && (
                                        <div className="text-center">
                                            <i className="fas fa-spinner fa-spin fa-2x"></i>
                                            <p>Cargando plantillas...</p>
                                        </div>
                                    )}
                                    
                                    {!loading && plantillas.length === 0 && (
                                        <div className="alert alert-info">
                                            <i className="fas fa-info-circle"></i> No hay plantillas creadas. 
                                            Haga clic en "Nueva Plantilla" para crear una.
                                        </div>
                                    )}
                                    
                                    {!loading && plantillas.length > 0 && (
                                        <div className="table-responsive">
                                            <table className="table table-bordered table-striped">
                                                <thead>
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>Nombre</th>
                                                        <th>Especialidad</th>
                                                        <th>Descripción</th>
                                                        <th>Estado</th>
                                                        <th>Fecha Creación</th>
                                                        <th>Acciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {plantillas.map(plantilla => (
                                                        <tr key={plantilla.id}>
                                                            <td>{plantilla.id}</td>
                                                            <td><strong>{plantilla.nombre}</strong></td>
                                                            <td>
                                                                {plantilla.especialidad ? (
                                                                    <span className="badge badge-info">
                                                                        {plantilla.especialidad}
                                                                    </span>
                                                                ) : (
                                                                    <span className="text-muted">Sin especialidad</span>
                                                                )}
                                                            </td>
                                                            <td>{plantilla.descripcion || '-'}</td>
                                                            <td>
                                                                {plantilla.activo == 1 ? (
                                                                    <span className="badge badge-success">Activo</span>
                                                                ) : (
                                                                    <span className="badge badge-secondary">Inactivo</span>
                                                                )}
                                                            </td>
                                                            <td>
                                                                {new Date(plantilla.created_at).toLocaleDateString()}
                                                            </td>
                                                            <td>
                                                                <button
                                                                    className="btn btn-sm btn-dark mr-1"
                                                                    onClick={() => history.push(`/asignar-plantillas-historia-clinica?plantilla_id=${plantilla.id}`)}
                                                                    title="Asignar a usuarios"
                                                                >
                                                                    <i className="fas fa-users"></i>
                                                                </button>
                                                                <button
                                                                    className="btn btn-sm btn-danger"
                                                                    onClick={() => eliminarPlantilla(plantilla.id, plantilla.nombre)}
                                                                    title="Eliminar"
                                                                >
                                                                    <i className="fas fa-trash"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                
                <Footer />
            </div>
        </div>
    );
}

export default PlantillasHistoriaClinica;
